import { DEFAULT_TRACK_HIDDEN } from '../constants.js';
import { AnnotationsMarkerConfig } from '../types/annotations-marker-props.js';
import {
  AnnotationsTrackProps,
  AnnotationsTrackConfig,
} from '../types/annotations-track-props.js';

type PartialTrackConfig = AnnotationsTrackProps & {
  markers: AnnotationsMarkerConfig[];
};

/**
 * Populates missing track props with defaults
 *
 * @param trackProps -
 */
export const populateMissingTrackProps = (
  trackProps: PartialTrackConfig,
): AnnotationsTrackConfig => {
  const defaults = {
    hidden: DEFAULT_TRACK_HIDDEN,
  };

  // removed merge from lodash because of a weird behavior
  return { ...defaults, ...trackProps };
};
